import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { AddButton } from '_components';
import styles from './Common.module.css';

class PatientCareCenterNoteGoalsFotoRow extends React.Component {


    addFotoGoal() {
        this.props.addGoal(this.props.noteId, this.props.activity.PRQUESTION, true);
    }

    render() {
        let noteTypes = [1, 3, 5];
        return (
            <div className={styles.foto_row}>
                <div className={styles.foto_inset} />
                <div className={styles.foto_add_button}>
                    {!this.props.isWc && noteTypes.includes(this.props.noteType) &&  
                        <AddButton size='extra-small' title='Add as Goal' onClick={() => this.addFotoGoal()} />
                    }
                </div>

                <div className={styles.foto_activity} title={this.props.activity.PRQUESTION}>
                    {this.props.activity.PRQUESTION}
                </div>
                <div className={styles.foto_limit}>
                    {this.props.activity.PRRESPONSE}
                </div>
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addGoal: bindActionCreators(noteActions.addGoal, dispatch)
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;

    return {
        noteId: noteId,
        activity: state.entities.notes.FOTOPATIENTRESPONSE[ownprops.id],
        isWc: state.entities.admissions[epno].isWc
    };
}

const connectedPatientCareCenterNoteGoalsFotoRow = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsFotoRow);
export { connectedPatientCareCenterNoteGoalsFotoRow as PatientCareCenterNoteGoalsFotoRow };

